import request from '../network';

export const getFreeSelfCouponApi = (shopId: any, putKey: string) => {
  return request({
    url: '/member/royalcanin/admin/coupon/getFreeSelfCoupon',
    method: 'GET',
    params: { shopId, putKey },
  });
};

export const savePlatformCouponApi = (shopId: any, data: any) => {
  return request({
    url: '/member/royalcanin/admin/coupon/savePlatformCoupon',
    method: 'POST',
    data: { ...data, shopId },
  });
};

export const updateCouponByIdApi = (shopId: any, data: any) => {
  return request({
    url: '/member/royalcanin/admin/coupon/updateCouponById',
    method: 'POST',
    data: { ...data, shopId },
  });
};

export const queryCouponListApi = (params: any) => {
  return request({
    url: '/member/royalcanin/admin/coupon/queryCouponList',
    method: 'POST',
    data: params,
  });
};

export const deleteCouponApi = (id: number) => {
  return request({
    url: '/member/royalcanin/admin/coupon/deleteCoupon',
    method: 'POST',
    data: { id },
  });
};

export const getCouponDetailApi = (id: number) => {
  return request({
    url: '/member/royalcanin/admin/coupon/detail',
    method: 'GET',
    params: { id },
  });
};

export const getCouponDetailByCouponIdApi = (params: { shopId: string | number; couponId: string | number }) => {
  return request({
    url: '/member/royalcanin/admin/coupon/detailByCouponId',
    method: 'GET',
    params,
  });
};

export const getCouponReportApi = (params: { id: string | number; shopId: string | number }) => {
  return request({
    url: '/member/royalcanin/admin/coupon/getCouponReport',
    method: 'GET',
    params,
  });
};

export const sendBatchCouponApi = (data: {
  channel: string;
  couponId: string | number;
  reason: string;
  shopId: string | number;
  userIdStr: string;
}) => {
  return request({
    url: '/member/royalcanin/admin/coupon/sendBatchCoupon',
    method: 'POST',
    data,
  });
};
